export const PUBLIC_ENDPOINTS = new Set([
  'login',
  'register',
  'resetPassword',
  'sessionCheck',
]);

export const MAX_RETRY_REQUEST_ATTEMPTS = 3;

export const RETRYABLE_MUTATIONS = new Set([
  'renameChat',
  'pinChat',
  'changUserName',
]);
